export default {
  name: 'project',
  translationKey: 'project-module',
  routePrefix: 'project',
  routeNamePrefix: 'project',
  directRoutesAvailable: true,
}
